"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@ali/dingtalk-jsapi/entry/union");
var ut_1 = require("@ali/dingtalk-jsapi/api/biz/util/ut");
// const isDev = !(window.location.hostname.indexOf('dingtalk') > -1)
var ua = (window && window.navigator.userAgent.toLowerCase()) || '';
var isAndroid = ua.indexOf('android') !== -1 || ua.indexOf('linux') > -1;
var isInDD = ua.indexOf('dingtalk') > -1;
var getwtid = function () {
    if (!window) {
        return '';
    }
    var url = window.location.href;
    if (url.indexOf('wtid=') > -1) {
        // index.html?wtid=test&from=xx/#/hash
        // index.html?from=xx&wtid=test/#/hash
        // index.html/#/hash?from=xx&wtid=test
        var path = url.split('wtid=')[1];
        var split1 = path.split('&')[0];
        var split2 = split1.split('/')[0];
        var split3 = split2.split('#')[0];
        return decodeURIComponent(split3);
        // return split3
    }
    else {
        return getpage();
    }
};
var indexPageList = ['index', 'index.html'];
// 得到页面非index.html那一级
var getpage = function () {
    if (!window) {
        return '';
    }
    var url = window.location.pathname;
    var pathSplit = url.split('/');
    var page = '';
    for (var i = pathSplit.length - 1; i >= 0; i--) {
        var path = pathSplit[i];
        if (indexPageList.indexOf(path) < 0) {
            page = path;
            break;
        }
    }
    if (!page) {
        page = pathSplit.join('_');
    }
    return page;
};
var trace = {
    wtidFullStr: getwtid(),
    wtid: '',
    page: getpage(),
    from: '',
    mode: 'h5',
    setConfig: function (_a) {
        var _b = _a.page, page = _b === void 0 ? '' : _b, _c = _a.wtid, wtid = _c === void 0 ? '' : _c, _d = _a.mode, mode = _d === void 0 ? 'h5' : _d;
        var t = this;
        t.page = page;
        t.wtidFullStr = wtid;
        t.mode = mode;
    },
    startTime: +new Date(),
    scrollPos: 0,
    index: 0,
    log: function (data) {
        var t = this;
        // console.log('log1:', t.wtidFullStr)
        if (!t.wtidFullStr) {
            return;
        }
        if (!t.wtid || !t.from) {
            var wtidSplit = t.wtidFullStr.split('__');
            if (t.wtidFullStr.indexOf('|') > -1) {
                wtidSplit = t.wtidFullStr.split('|');
            }
            t.wtid = wtidSplit[0];
            t.from = wtidSplit[1] || 'wtpush';
        }
        // console.log('log2:', t.wtid, t.from)
        if (!t.wtid) {
            return;
        }
        if (t.mode === 'h5') {
            if (!isInDD) {
                return;
            }
            t.h5Log(data);
        }
        else if (t.mode === 'miniapp') {
            t.miniappLog(data);
        }
    },
    h5Log: function (data) {
        var t = this;
        var key = "watt" + '\u000b' + t.wtid + '\u000b' + (data.page ? data.page : t.page) + '\u000b' + data.type + '\u000b' + (data.position ? data.position : '') + '\u000b' + t.from;
        var value = __assign(__assign({}, data.extParams), { wtid: t.wtid, from: t.from, index: t.index });
        // if (isDev && data.type !== 'scroll') {
        //   console.log('wtid:', t.wtid, 'page:', t.page, data.page, 'pos:', data.position, 'type', data.type)
        //   console.log('key:', key)
        // }
        if (data.type === 'scroll' && t.mode === 'h5') {
            // 大于500上报一次
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (Math.abs(t.scrollPos - scrollTop) < 500) {
                return;
            }
            else {
                // console.log('key:', key);
                t.scrollPos = scrollTop;
            }
        }
        if (data.type === 'pageload') {
            t.startTime = +new Date();
            // 增加页面关闭的监听
            var visiHandler = function () {
                if (document.hidden) {
                    var visiKey = "watt" + '\u000b' + t.wtid + '\u000b' + (data.page ? data.page : t.page) + '\u000b' + "stay" + '\u000b' + (+new Date() - t.startTime) + '\u000b' + t.from;
                    // console.log(9999, key);
                    if (isInDD) {
                        ut_1.default({ key: visiKey, value: value });
                    }
                }
            };
            // 离开页面的监听
            var leaveHandler_1 = function () {
                var leaveKey = "watt" + '\u000b' + t.wtid + '\u000b' + (data.page ? data.page : t.page) + '\u000b' + "stay" + '\u000b' + (+new Date() - t.startTime) + '\u000b' + t.from;
                // console.log(888, key);
                if (isInDD) {
                    ut_1.default({ key: leaveKey, value: value });
                }
            };
            if (isAndroid) {
                window.onunload = function () {
                    leaveHandler_1();
                };
            }
            else {
                document.removeEventListener('pagehide', leaveHandler_1);
                window.addEventListener('pagehide', leaveHandler_1);
            }
            document.removeEventListener('visibilitychange', visiHandler);
            document.addEventListener('visibilitychange', visiHandler);
        }
        if (isInDD) {
            ut_1.default({ key: key, value: value });
            var stayKey = "watt" + '\u000b' + t.wtid + '\u000b' + (data.page ? data.page : t.page) + '\u000b' + "stay" + '\u000b' + (+new Date() - t.startTime) + '\u000b' + t.from;
            ut_1.default({ key: stayKey, value: value });
        }
        t.index = t.index + 1;
    },
    miniappLog: function (data) {
        var t = this;
        var key = "watt" + '\u000b' + t.wtid + '\u000b' + (data.page ? data.page : t.page) + '\u000b' + data.type + '\u000b' + (data.position ? data.position : '') + '\u000b' + t.from;
        var value = __assign(__assign({}, data.extParams), { wtid: t.wtid, from: t.from, index: t.index });
        if (data.type === 'pageload') {
            t.startTime = +new Date();
        }
        // console.log('log3:', key)
        ut_1.default({ key: key, value: value });
        var stayKey = "watt" + '\u000b' + t.wtid + '\u000b' + (data.page ? data.page : t.page) + '\u000b' + "stay" + '\u000b' + (+new Date() - t.startTime) + '\u000b' + t.from;
        ut_1.default({ key: stayKey, value: value });
        t.index = t.index + 1;
    },
};
// 要解析的特殊链接的标记 和 对应的key
var dingtalkUrlKeyMapList = [{
        key: '/open_platform_link',
        val: ['pcLink', 'mobileLink'],
    }, {
        key: '/page/link',
        val: ['url'],
    }, {
        key: '/page/connectionCircleHome',
        val: ['detailUrl'],
    }];
var dingtalkUrlKeyList = ['pcLink', 'mobileLink', 'url', 'detailUrl'];
// 获取链接？后面的keyvalue
var getUrlKV = function (data) {
    if (!data) {
        return {};
    }
    var result = {};
    var splitData = data.split('&');
    splitData.forEach(function (item) {
        var itemSplit = item.split('=');
        result[itemSplit[0]] = itemSplit[1];
    });
    return result;
};
// 获取url的结构，找到最后实际的链接
var getUrlTree = function (url, wtid) {
    var prefix = url.split('?')[0];
    var urlKV = getUrlKV(url.split('?')[1]);
    var result = {
        prefix: prefix,
        dataSet: {},
    };
    var isFind = false;
    dingtalkUrlKeyMapList.forEach(function (keyMap) {
        if (prefix.indexOf(keyMap.key) > -1) {
            isFind = true;
            var dataSet = {};
            for (var urlKey in urlKV) {
                if (keyMap.val.indexOf(urlKey) > -1) {
                    var urlStr = urlKV[urlKey];
                    urlStr = decodeURIComponent(urlStr);
                    dataSet[urlKey] = getUrlTree(urlStr, wtid);
                }
                else {
                    dataSet[urlKey] = urlKV[urlKey];
                }
            }
            result.dataSet = dataSet;
        }
    });
    if (!isFind) {
        result = {
            prefix: addUrlWtid(url, wtid),
        };
    }
    return result;
};
// 有hash情况的链接追加wtid
var addHashParam = function (url, wtid, isAnd) {
    var urlSplit = url.split('#');
    var firstPath = urlSplit[0];
    var endWithSlash = false;
    if (firstPath.endsWith('/')) {
        endWithSlash = true;
        firstPath = firstPath.substring(0, firstPath.length - 1);
    }
    return "" + firstPath + (isAnd ? '&' : '?') + "wtid=" + wtid + (endWithSlash ? '/' : '') + "#" + urlSplit[1];
};
// 链接追加wtid
// 1.https://h5.dingtalk.com/xx.html#/xxx?xxx=123 -> https://h5.dingtalk.com/xx.html#/xxx?xxx=123&wtid=wt
// 2.https://h5.dingtalk.com/xx.html?xxx=123/#/xxx -> https://h5.dingtalk.com/xx.html?xxx=123&wtid=wt/#/xxx
// 3.https://h5.dingtalk.com/xx.html#/xxx -> https://h5.dingtalk.com/xx.html#/xxx?wtid=wt
// 4.https://h5.dingtalk.com/xx.html/#/xxx -> https://h5.dingtalk.com/xx.html/#/xxx?wtid=wt
// 5.dingtalk://dingtalkclient/action/open_mini_app?miniAppId=123&page=pages%2Fasd%2Fzxc%3Fid%3D22%26td%3D17 -> dingtalk://dingtalkclient/action/open_mini_app?miniAppId=123&page=pages%2Fasd%2Fzxc%3Fid%3D22%26td%3D17&query=wtid%3Dwt
var addUrlWtid = function (url, wtid) {
    if (url.indexOf('wtid') > -1) {
        return url;
    }
    if (url.startsWith('http')) {
        if (url.indexOf('?') > -1) {
            var urlSplit = url.split('?');
            if (urlSplit[1].indexOf('#') > -1) {
                // 2.
                return urlSplit[0] + "?" + addHashParam(urlSplit[1], wtid, true);
            }
            else {
                // 1.
                return url + "&wtid=" + wtid;
            }
        }
        else if (url.indexOf('#') > -1) {
            // 3,4
            return addHashParam(url, wtid, false);
        }
        else {
            return url + "?wtid=" + wtid;
        }
    }
    // 5.
    if (url.startsWith('dingtalk://dingtalkclient/action/open_mini_app')) {
        if (url.indexOf('query=') > -1) {
            var urlSplit = url.split('query=');
            return urlSplit[0] + "query=wtid%3D" + wtid + "%26" + urlSplit[1];
        }
        else {
            return url + "&query=wtid%3D" + wtid;
        }
    }
    return url;
};
// 组合url的树形结构
var combinUrlTree = function (urlTree) {
    var result = '';
    if (!urlTree.data) {
        result = urlTree.prefix;
    }
    for (var key in urlTree.dataSet) {
        if (dingtalkUrlKeyList.indexOf(key) > -1) {
            var val = encodeURIComponent(combinUrlTree(urlTree.dataSet[key]));
            result = "" + result + (result.indexOf('?') > -1 ? '&' : '?') + key + "=" + val;
        }
        else {
            result = "" + result + (result.indexOf('?') > -1 ? '&' : '?') + key + "=" + urlTree.dataSet[key];
        }
    }
    return result;
};
// 一个不确定encode过几次的url，获取最终的链接并且追加url-wtid参数的方法
var addwtid = function (url, wtid) {
    var jumpUrl = url;
    var currentWtid = wtid ? wtid : getwtid();
    if (!currentWtid) {
        return jumpUrl;
    }
    if (!(currentWtid.indexOf('__') > -1)) {
        currentWtid = currentWtid + '__wtpush';
    }
    if (currentWtid.indexOf('|') > -1) {
        currentWtid = currentWtid.replace('|', '__');
    }
    currentWtid = encodeURIComponent(currentWtid);
    var urlTree = getUrlTree(jumpUrl, currentWtid);
    // console.log(999, JSON.stringify(urlTree));
    var finalUrl = combinUrlTree(urlTree);
    // console.log(888, finalUrl);
    // if (isDev) {
    //   console.log('getUrlTree:', JSON.stringify(urlTree))
    //   console.log('jumpUrl_addwtid:', finalUrl)
    // }
    return finalUrl;
};
exports.default = {
    trace: trace,
    addwtid: addwtid,
    getwtid: getwtid,
};
